import {
  IM_INPUT_STYLINGS,
  IMInputSize,
} from '@insurancemenu/imenu-components-lib/dist/components/imForm/sharedStylings';
import { breakpointsMQ4 } from '@insurancemenu/imenu-components-lib/dist/utils/breakpoints';
import styled, { css, CSSProp } from 'styled-components';
import TaggedSelect from 'components/common/form/TaggedSelect';

export const TaggedSelectStyled = styled(TaggedSelect)<{ $size?: IMInputSize }>`
  width: 100%;
  ${({ $size }): CSSProp =>
    $size &&
    css`
      flex: 0 0 ${IM_INPUT_STYLINGS[$size].flexBasis};
    `};

  ${breakpointsMQ4.sm.down} {
    flex-basis: 100%;
  }
`;
